// NavbarModule.js
import React, { forwardRef } from 'react'
import styled from "./NavbarModule.module.css"
import { useNavigate } from 'react-router-dom'
import { signOut } from 'firebase/auth'
import { auth } from '../../../firebase/firebase'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
const NavbarModule = forwardRef(({ img }, ref) => {
  const { t } = useTranslation()
  const { logged, role } = useSelector((state) => state.login)
  const navigate = useNavigate()
  
  const logOut = async () => {
    try {
      await signOut(auth)
      navigate("/login")
    } catch (error) {
    }
  }
  
  return (
    <>
      {role === "student" ?
        <div ref={ref} className={styled.container}>
          <ul>
            <li onClick={() => navigate('/student-profile')}>{t('NavbarModule.profile')}</li>
            <li onClick={() => navigate('/contact')}>{t('NavbarModule.contact')}</li>
            <li onClick={logOut}>{t('NavbarModule.logout')}</li>
          </ul>
        </div>
        :
        <div ref={ref} className={styled.container}>
          <ul>
            <li onClick={() => navigate('/profile')}>Profile</li>
            <li onClick={() => navigate('/contact')}>Contact</li>
            <li onClick={logOut}>Logout</li>
          </ul>
        </div>
      }
    </>
  )
})

export default NavbarModule